/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import environment from "modules/environment";

/**
 * Utility function to return the current language, including the locale.
 * I.e. 'en-gb' -> 'en-gb'
 */
export function getLanguage() {
    const language = environment.get("language", null);

    if (language === null) {
        return "en-us";
    }

    return language;
}

/**
 * Utility function to return the current language without the locale.
 * I.e. 'en-gb' -> 'en'
 */
export function getLanguageWithoutLocale() {
    const language = environment.get("language", null);

    if (language === null) {
        return "en";
    }

    return language.split("-")[0];
}

/**
 * Utility function to determine if the application is in the English language.
 *
 * Always return true if force show English-only features is switched on
 */
export function languageIsEnglish() {
    if (environment.get("forceShowEnglishOnlyFeatures", false)) {
        return true;
    }

    const language = environment.get("language", null);

    return language === null || language.startsWith("en");
}

